export default "__VITE_ASSET__23927547__"